import React, { useState } from "react";
import {
  FaPlay,
  FaCopy,
  FaDownload,
  FaSearch,
  FaCode,
  FaBook,
} from "react-icons/fa";
import { ASSETS } from "../config/assets";

const ApiDocumentation = () => {
  const [activeTab, setActiveTab] = useState("sms");

  const apiEndpoints = {
    sms: {
      title: "SMS API",
      description: "Send SMS messages globally with high delivery rates",
      endpoints: [
        {
          method: "POST",
          path: "/api/v1/sms/send",
          description: "Send a single SMS message",
          example: `{
  "to": "+1234567890",
  "message": "Hello from ${ASSETS.brandName}!",
  "from": "${ASSETS.brandName}"
}`,
        },
      ],
    },
    email: {
      title: "Email API",
      description:
        "Send transactional and marketing emails with advanced features",
    },
    voice: {
      title: "Voice API",
      description: "Make voice calls and send voice messages programmatically",
    },
  };

  return (
    <div className="container-fluid">
      <div className="row mb-4">
        <div className="col">
          <h1 className="h3 mb-0">API Documentation</h1>
          <p className="text-muted">Complete reference for {ASSETS.brandName} APIs</p>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-8">
          <div className="input-group">
            <span className="input-group-text">
              <FaSearch />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search APIs..."
            />
          </div>
        </div>
        <div className="col-md-4 text-end">
          <button className="btn btn-outline-primary me-2">
            <FaDownload className="me-2" />
            Download SDK
          </button>
          <button className="btn btn-primary">
            <FaBook className="me-2" />
            API Reference
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">API Categories</h5>
            </div>
            <div className="card-body p-0">
              <nav className="nav nav-pills flex-column">
                {Object.entries(apiEndpoints).map(([key, api]) => (
                  <a
                    key={key}
                    href="#"
                    className={`nav-link d-flex align-items-center p-3 ${activeTab === key ? "active" : ""}`}
                    onClick={() => setActiveTab(key)}
                  >
                    <FaCode className="me-2" />
                    {api.title}
                  </a>
                ))}
              </nav>
            </div>
          </div>
        </div>

        <div className="col-md-9">
          <div className="card">
            <div className="card-header">
              <h4 className="mb-0">{apiEndpoints[activeTab].title}</h4>
              <p className="text-muted mb-0 mt-2">
                {apiEndpoints[activeTab].description}
              </p>
            </div>
            <div className="card-body">
              <p>
                API documentation for {apiEndpoints[activeTab].title} will be
                displayed here.
              </p>
              <button className="btn btn-primary">
                <FaPlay className="me-2" />
                Test Endpoint
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiDocumentation;
